import service from '@/service';

// 成绩-成绩查询
export const getExamStudentScores = (params: ExamScoreParam) =>
  service.get<BackendDataWithPage<ExamStudentScore>>(`/edu/mana/exam/${params.examId}/examstudentscores`, params);

// 成绩-修改成绩
export const modifyExamStudentScores = (params: ScoreModifyParam) =>
  service.put<boolean>(`/edu/mana/exam/${params.examId}/examcoursestudent`, params);

// 成绩-分页查询成绩修改记录
export const getModifyHistory = (params: {pageNum: number; pageSize: number; examId: number}) =>
  service.get<BackendDataWithPage<ScoreModifyHistoryList>>(`/edu/mana/exam/${params.examId}/scoremodifyrecord`, params);
